import { usePathname, useRouter, useSearchParams } from 'next/navigation.js';
import { type SectionType } from '../enums/mediaTypes.ts';
import { type ActiveMediaTypeParams } from '../types.ts';

export const useActivePreviewParams = (): [
  ActiveMediaTypeParams | undefined,
  (params: ActiveMediaTypeParams | undefined) => void,
] => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const previewId = searchParams.get('previewId');
  // searchParams.get does not support generics
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const previewType = searchParams.get('previewType') as SectionType | undefined;
  const params = previewId && previewType ? { id: previewId, type: previewType } : undefined;

  const setParams = (newParams: ActiveMediaTypeParams | undefined) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());

    if (newParams) {
      newSearchParams.append('previewId', String(newParams.id));
      newSearchParams.append('previewType', newParams.type);
    } else {
      newSearchParams.delete('previewId');
      newSearchParams.delete('previewType');
    }

    if (newSearchParams.size > 0) {
      router.push(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
    } else {
      router.push(pathname, { scroll: false });
    }
  };

  return [params, setParams];
};
